import { render, staticRenderFns } from "./shipment-detail.vue?vue&type=template&id=217d077c&scoped=true"
import script from "./shipment-detail.vue?vue&type=script&lang=js"
export * from "./shipment-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217d077c",
  null
  
)

export default component.exports